import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '../index'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const WINDING_METHOD_URL = `${POSITION_PROPERTY_URL}/winding-methods`

const errors = createHandbookResponseErrors('способ навивки', 'способов навивки')

export const WindingMethodApi = createNewHandbookApi(WINDING_METHOD_URL, errors)
